import React from "react";
import PropTypes from "prop-types";
import Marker from "./marker";
import { FormattedMessage } from "react-intl";
import _ from "lodash";

export default class MarkerGroup extends React.Component {
  render() {
    const { data, basic, hasDetails } = this.props;
    const {
      name,
      description,
      biomarkers = biomarkers && [].concat(biomarkers),
    } =
      data || {};

    return (
      <section>
        {name &&
          !_.isEmpty(name) && (
            <h4>
              <FormattedMessage
                id={(name || "").trim()}
                defaultMessage={name}
              />
            </h4>
          )}
        {description &&
          !_.isEmpty(description) && (
            <p>
              <FormattedMessage
                id={(description || "").trim()}
                defaultMessage={description}
              />
            </p>
          )}
        {biomarkers &&
          biomarkers.map((marker, index) => (
            <Marker
              marker={marker}
              key={index}
              basic={basic}
              hasDetails={hasDetails}
            />
          ))}
      </section>
    );
  }
}

MarkerGroup.propTypes = {
  data: PropTypes.object,
  basic: PropTypes.bool,
  hasDetails: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./components/employee/wellness/markerGroup.jsx